"use client";

import { BSRArrowRight } from "./bsr/BSRArrowRight";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { ArrowRight as LegacyArrowRight } from "./legacy/ArrowRight";

export const ArrowRight = createBSRExperimentIcon(
  LegacyArrowRight,
  BSRArrowRight
);
